import { formatNumber } from "../../utils/largeNumberFormatting"
import { V3CaptionGrey48 } from "../ReusableStyledComponents/V3CaptionGrey48"
import { V3Body } from "../Typography"
import { ReportMobileContent } from "./V3SharesReportDesktop.styles"

interface ShareReportMobileProps {
    icon?: JSX.Element,
    label: string,
    number: number | null,
    isMain?: boolean
}

export const ShareReportMobile = ({ icon, label, number, isMain = true }: ShareReportMobileProps) => {
    const WrapperToUse = isMain ? V3Body : V3CaptionGrey48;

    return <ReportMobileContent>
        <div>{icon}</div>
        <div>
            <WrapperToUse>{label}</WrapperToUse>
        </div>
        <div>
            <WrapperToUse><strong>{formatNumber(number)}</strong></WrapperToUse>
        </div>
    </ReportMobileContent>
}